// extracted by mini-css-extract-plugin
module.exports = {"grid-3-1":"TileGridAccountFavorites_grid-3-1_3UdYA","grid":"TileGridAccountFavorites_grid_1HR16","grid-3-2":"TileGridAccountFavorites_grid-3-2_2bCan"};